/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Timeline_Outcome_InterruptedInputs */



/**
* | output |
* | --- |
* | "stopped" |
*
* @param {Chat_Timeline_Outcome_InterruptedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_timeline_outcome_interrupted = /** @type {((inputs?: Chat_Timeline_Outcome_InterruptedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Timeline_Outcome_InterruptedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("abgebrochen")
	return /** @type {LocalizedString} */ ("stopped")
});